<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="subset_name">
                                                {{ $t('money_request.tracking_number') + ' (' + $t('money_request.tracking_code') + ')' }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="tracking_number"
                                                name="tracking_number"
                                                id="tracking_number"
                                                v-model="query.tracking_number"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="price">
                                                {{ $t('label.price') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                ref="amount"
                                                name="amount"
                                                id="amount"
                                                v-model="query.amount"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('money_request.status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                size="3"
                                                id="status"
                                                class="form-control"
                                                name="status"
                                                v-model="query.status"
                                            >
                                                <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                                >
                                                    {{ status.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                color="#00c1a4"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="from_date"
                                                name= "from_date"
                                                v-model="query.from_date"
                                                type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                color="#00c1a4"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="to_date"
                                                name= "to_date"
                                                v-model="query.to_date"
                                                type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import { i18n } from '@/plugins/i18n'
import {moneyRequestPaymentStatus} from '@/constants/moneyRequestPaymentStatus'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true
        }
    },
    data() {
        return {
            query: {},
            moneyRequestPaymentStatus: moneyRequestPaymentStatus,
            statuses: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: i18n.t('money_request.pending'),
                    value: moneyRequestPaymentStatus.INIT
                },
                {
                    name: i18n.t('money_request.succeed_payment'),
                    value: moneyRequestPaymentStatus.SUCCESS
                },
            ]
        }
    },
    methods: {
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
}

</script>